export default {"src":"/_next/static/media/ic-check-active.cd08ea34.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};